import React from 'react';
import logoImage from '../../../assets/sosyal_logo.svg';

export interface LogoProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

export const Logo = ({
  className = '',
  size = 'medium',
  showText = false
}: LogoProps) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16',
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={logoImage}
        alt="Sosyal Logo"
        className={sizeClasses[size]}
      />
      {showText && (
        <span className="font-bold text-accent text-lg">Sosyal Moderator</span>
      )}
    </div>
  );
};

